import React from 'react';
import { Buffer } from 'buffer';
import ReactDOM from 'react-dom';
import EnvironmentBanner from 'components/Base/EnvironmentBanner';
import './reloadOnStaleChunk';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.global ||= window;
global.Buffer = Buffer;

ReactDOM.render(
  <React.StrictMode>
    <EnvironmentBanner />
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
